// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import CoolingShelfApi from "../Apis/CoolingShelfApi";
import ShelfLifeApi from "../Apis/ShelfLifeApi";

const ShelfLifeModel = ({ onShelfResponse }) => {

    const [ShelfLife, setShelfLifes] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadShelfLifeClicked, setIsReloadShelfLifeClicked] =
        useState(false);

    const handleReloadShelfLifesClick = async () => {
        setIsReloadShelfLifeClicked(true);

        try {
            setLoading(true);

            let currentPage = 0;
            let totalPages = 1;
            let allShelfLifes = [];

            do {
                const response = await ShelfLifeApi.ListShelfLife(currentPage,10);
                totalPages = response?.totalPages;
                allShelfLifes = [...allShelfLifes, ...(response?.payloadDto || [])];
                currentPage++;

            } while(currentPage < totalPages);

            setTotalPageNew(totalPages);
            setShelfLifes(allShelfLifes);
            setPage(currentPage);

            }
            catch(error) {
                console.log("error fetching shelf lifes", error);
            } finally {
                setLoading(false);
            }

        setTimeout(() => {
            setIsReloadShelfLifeClicked(false);
        }, 1000);
    };

    const handleChangeProduct = (value) => {

        ShelfLifeApi.SingleShelfLife(value).then((response) => {
            onShelfResponse(response.payload);
        })
            .catch((err) => {
                console.log(err);
            });
    };

    const fetchShelfLifes = async () => {
        try {
            setLoading(true);

            let currentPage = 0;
            let totalPages = 1;
            let allShelfLifes = [];

            do {
                const response = await ShelfLifeApi?.ListShelfLife(currentPage,10);
                totalPages = response?.totalPages || 0;
                allShelfLifes = [...allShelfLifes, ...(response?.payloadDto || [])];
                currentPage++;
            } while (currentPage < totalPages);

            setTotalPageNew(totalPages);
            setPage(currentPage);
            setShelfLifes(allShelfLifes);

        } catch (error) {
            console.error('Error fetching shelf lifes:', error);
        } finally {
            setLoading(false);
        }
    };
 
    useEffect(() => {
        fetchShelfLifes();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="ShelfLifeID"
                label="Shelf Life :"
                className="text-lable col-10"
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Shelf Life"
                    onChange={(value) => handleChangeProduct(value)}
                >
                    {ShelfLife.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.description}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadShelfLifeClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadShelfLifesClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link to={"/masters/shelf-life/add-shelf-life"} target="_blank">
                        <u>Create New Shelf Life</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default ShelfLifeModel;
